module.exports = __webpack_public_path__ + "static/amberlylocal-b313875dd4bc7ab956daf6833e388042.png";